export default __webpack_public_path__ + "static/media/sprinternotext.fa0b6cab.jpg";